import { render, staticRenderFns } from "./playlist-table-card.vue?vue&type=template&id=7453fbee&scoped=true&"
import script from "./playlist-table-card.vue?vue&type=script&lang=ts&"
export * from "./playlist-table-card.vue?vue&type=script&lang=ts&"
import style0 from "./playlist-table-card.vue?vue&type=style&index=0&id=7453fbee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7453fbee",
  null
  
)

export default component.exports